import React, { Component } from 'react'
import axios from "axios";
import { API_BASE_URL, PIN_CODE_PATTERN, TYPE_SUCCESS, TYPE_FAIL, INTERVAL, WEB_APP_URL, FLOW_COLUMN_SELECTION_TRUE_VALUE, FLOW_COLUMN_SELECTION_OPTIONS, FLOW_COLUMN_LIST, LEVEL_COLUMN_LIST, LEVEL_COLUMN_SELECTION_TRUE_VALUE, LEVEL_COLUMN_SELECTION_OPTIONS, AMR_COLUMN_LIST, AMR_COLUMN_SELECTION_TRUE_VALUE, AMR_COLUMN_SELECTION_OPTIONS, SYSTEM_MODULES_TYPES } from "assets/constants/Constants";
import { SITE_ICON, COPY_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Select from 'react-select';
import { FaInfoCircle, FaColumns, FaBell, FaEnvelope, FaSms } from 'react-icons/fa';

export class CreateSitePage extends Component {
    constructor(props) {
        super(props)
        const superadminDefaults = {};
        const adminDefaults = {};
        const readerDefaults = {};
        const flowColumns = FLOW_COLUMN_LIST
        flowColumns.forEach(column => {
            superadminDefaults[column.field] = true;
            adminDefaults[column.field] = true;
            readerDefaults[column.field] = true;
        });

        const levelSuperAdminDefaults = {};
        const levelAdminDefaults = {};
        const levelReaderDefaults = {};
        const levelColumns = LEVEL_COLUMN_LIST;
        levelColumns.forEach(column => {
            levelSuperAdminDefaults[column.field] = true;
            levelAdminDefaults[column.field] = true;
            levelReaderDefaults[column.field] = true;
        });

        const editData = this.props.history.location.state;
        console.log("editData::", editData)
        const columnAccessData = editData && editData.flow_column_access ? {
            superadmin: editData.flow_column_access.superadmin || superadminDefaults,
            admin: editData.flow_column_access.admin || adminDefaults,
            reader: editData.flow_column_access.reader || readerDefaults
        } : { superadmin: superadminDefaults, admin: adminDefaults, reader: readerDefaults };
        const levelColumnAccessData = editData && editData.level_column_access ? {
            superadmin: editData.level_column_access.superadmin || levelSuperAdminDefaults,
            admin: editData.level_column_access.admin || levelAdminDefaults,
            reader: editData.level_column_access.reader || levelReaderDefaults
        } : { superadmin: levelSuperAdminDefaults, admin: levelAdminDefaults, reader: levelReaderDefaults };
        const amrSuperAdminDefaults = {};
        const amrAdminDefaults = {};
        const amrReaderDefaults = {};
        const amrColumns = AMR_COLUMN_LIST;
        amrColumns.forEach(column => {
            amrSuperAdminDefaults[column.field] = true;
            amrAdminDefaults[column.field] = true;
            amrReaderDefaults[column.field] = true;
        });
        const amrColumnAccessData = editData && editData.amr_column_access ? {
            superadmin: editData.amr_column_access.superadmin || amrSuperAdminDefaults,
            admin: editData.amr_column_access.admin || amrAdminDefaults,
            reader: editData.amr_column_access.reader || amrReaderDefaults
        } : { superadmin: amrSuperAdminDefaults, admin: amrAdminDefaults, reader: amrReaderDefaults };

        const tempDeviceType = editData && Array.isArray(editData.device_type_value) ? editData.device_type_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        const tempsubModuleFeatureValue = editData && Array.isArray(editData.sub_module_feature_value) ? editData.sub_module_feature_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        const amiSystemReceiverTypeValue = editData && Array.isArray(editData.ami_amr_remote_system_receiver_type_value) ? editData.ami_amr_remote_system_receiver_type_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        const systemModuleTypeValue = editData && Array.isArray(editData.system_type_value) ? editData.system_type_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];

        let initialSystemReceiverType = [];
        if (systemModuleTypeValue && systemModuleTypeValue.length > 0) {
            const labels = systemModuleTypeValue.map(item => item.label);
            if (labels.includes("Ami Systems")) {
                initialSystemReceiverType.push({ value: "Gateway", label: "Gateway" }, { value: "Mqtt Devices", label: "Mqtt Devices" });
            }
            if (labels.includes("Amr Systems")) {
                initialSystemReceiverType.push({ value: "Aqualink", label: "Aqualink" });
            }
            if (labels.includes("Ami + Amr Systems")) {
                initialSystemReceiverType.push({ value: "Gateway + Aqualink", label: "Gateway + Aqualink" });
            }
            if (labels.includes("Ami + Remote Configuration")) {
                initialSystemReceiverType.push({ value: "Mqtt Devices", label: "Mqtt Devices" });
            }
            initialSystemReceiverType = initialSystemReceiverType.filter((value, index, self) => index === self.findIndex(t => t.value === value.value));
        }

        this.state = {
            isLoading: true,
            defaultBackgroundImageOrUplodedImageType: editData === null || editData.defaultImage_uploadedImage === undefined || editData.defaultImage_uploadedImage === "" || editData.defaultImage_uploadedImage === null ? "" : (editData && editData.defaultImage_uploadedImage.base64Data) ? this.getFileNameFromEditData(editData.defaultImage_uploadedImage) : (editData && editData.defaultImage_uploadedImage) ? this.getUrleFromEditData(editData.defaultImage_uploadedImage) : editData.defaultImage_uploadedImage,
            backgroundImageSelectedType: editData === null ? "" : editData.background_image_selected_type,
            clientName: editData === null ? null : editData.client_name,
            clientID: editData === null ? "" : editData.client_id,
            primaryLogoImage: editData === null || editData.client_logoImage_primary === undefined || editData.client_logoImage_primary === "" || editData.client_logoImage_primary === null ? "" : (editData.client_logoImage_primary.base64Data) ? this.getFileNameFromEditData(editData.client_logoImage_primary) : (editData.client_logoImage_primary) ? this.getUrleFromEditData(editData.client_logoImage_primary) : "",
            secondaryLogoImage: editData === null || editData.client_logoImage_secondary === undefined || editData.client_logoImage_secondary === "" || editData.client_logoImage_secondary === null ? "" : (editData.client_logoImage_secondary.base64Data) ? this.getFileNameFromEditData(editData.client_logoImage_secondary) : (editData.client_logoImage_secondary) ? this.getUrleFromEditData(editData.client_logoImage_secondary) : "",
            siteId: editData === null ? null : editData._id,
            siteName: editData === null ? "" : editData.site_name,
            siteStreet: editData === null ? "" : editData.street,
            siteCity: editData === null ? "" : editData.city,
            sitePincode: editData === null ? "" : editData.pincode,
            backendURL: editData === null ? "" : editData.backend_url,
            siteInactive: editData === null ? "" : editData.site_inactive,
            siteTodaysRedaingsToCheck: editData === null ? "" : editData.site_todays_readings_check,
            copiedIconClass: "",
            siteBackGroundImageSelectedList: [
                { value: "power plant", label: "Power plant" },
                { value: "hydro plant", label: "Hydro plant" },
                { value: "electricity plant", label: "Electricity plant" },
            ],
            siteBackGroundImageSelecteTypeList: [
                { value: "default images", label: "Default images" },
                { value: "upload", label: "Upload" }
            ],
            systemTypesList: [
                { value: "amr systems", label: "Amr Systems" },
                { value: "ami systems", label: "Ami Systems" },
                { value: "ami + amr systems", label: "Ami + Amr Systems" },
                { value: "Ami + Remote Configuration", label: "Ami + Remote Configuration" },
            ],
            deviceTypeValue: editData === null ? [] : tempDeviceType,
            systemTypeValue: editData === null ? [] : systemModuleTypeValue,
            systemReceiverType: initialSystemReceiverType,
            amiAmrRemoteSystemReceiverType: editData === null ? [] : amiSystemReceiverTypeValue,
            remoteSystemReceiverType: editData === null ? [] : { value: "Mqtt Devices", label: "Mqtt Devices" },
            amiSystemReceiverTypeList: [
                { value: "Gateway", label: "Gateway" },
                { value: "Mqtt Devices", label: "Mqtt Devices" },
            ],
            subModuleFeatureValue: editData === null ? [] : tempsubModuleFeatureValue,
            deviceTypesList: [
                { value: "Flow", label: "Flow" },
                { value: "Pressure", label: "Pressure" },
                { value: "Level", label: "Level" },
                { value: "Temperature", label: "Temperature" },
                { value: "OHT Solution", label: "OHT Solution" }
            ],
            deviceTypesListRemoteConfiguration: [
                { value: "Flow", label: "Flow" },
            ],
            flowColumnSelecetionValue: editData === null ? [] : { label: editData.flow_column_selection, value: editData.flow_column_selection },
            levelColumnSelecetionValue: (editData === null || !editData.level_column_selection) ? [] : { label: editData.level_column_selection, value: editData.level_column_selection },
            amrColumnSelecetionValue: (editData === null || !editData.amr_column_selection) ? [] : { label: editData.amr_column_selection, value: editData.amr_column_selection },
            flowColumnSelecetionOptions: FLOW_COLUMN_SELECTION_OPTIONS,
            amrColumnSelecetionOptions: AMR_COLUMN_SELECTION_OPTIONS,
            subModuleFeatureList: [
                { value: "location", label: "Location" },
                { value: "customeradd-billingcycle", label: "Customer Add - Billing Cycle" },
                { value: "notification", label: "Notification" }
            ],
            flowUnitValue: editData === null ? "" : { label: editData.flow_unit_value, value: editData.flow_unit_value },
            pressureUnitValue: editData === null ? "" : { label: editData.pressure_unit_value, value: editData.pressure_unit_value },
            levelUnitValue: editData === null ? "" : { label: editData.level_unit_value, value: editData.level_unit_value },
            temperatureUnitValue: editData === null ? "" : { label: editData.temperature_unit_value, value: editData.temperature_unit_value },
            flowUnitTypesList: [
                { value: "m³", label: "M³" },
                { value: "liter", label: "Liter" }
            ],
            pressureUnitTypesList: [
                { value: "bar", label: "Bar" },
                { value: "kg/cm²", label: "Kg/cm²" },
                { value: "mmh2o", label: "mmH2O" }
            ],
            levelUnitTypesList: [
                { value: "meter", label: "Meter" },
                { value: "mm", label: "MM" }
            ],
            temperatureUnitTypesList: [
                { value: "°c", label: "°C" },
                { value: "°f", label: "°F" }
            ],
            deviceTypeDisable: editData === null ? true : false,
            flowUnitDisable: editData === null ? true : false,
            pressureUnitDisable: editData === null ? true : false,
            levelUnitDisable: editData === null ? true : false,
            temperatureUnitDisable: editData === null ? true : false,
            error: {},
            columnAccess: columnAccessData,
            levelColumnAccess: levelColumnAccessData,
            amrColumnAccess: amrColumnAccessData,
            activeTab: 'siteDetails',
            customFlowColumnLabels: editData === null ? {} : editData.custom_flow_column_labels || {},
            customLevelColumnLabels: editData === null ? {} : editData.custom_level_column_labels || {},
            customAmrColumnLabels: editData === null ? {} : editData.custom_amr_column_labels || {},
            
            allEmailUsersList: [],
            allSmsUsersList: [],
            customersList: [],
            emailRecipients: editData === null ? [] : (editData.email_recipients || []).map(r => typeof r === 'object' ? r.value : r),
            smsRecipients: editData === null ? [] : (editData.sms_recipients || []).map(r => typeof r === 'object' ? r.value : r),
            notificationConfig: editData === null || !editData.notification_config ? {
                level_critical_status: { email_send: "No", sms_send: "No", send_frequency: "" },
                meter_inactive_status: { email_send: "No", sms_send: "No", send_frequency: "" }
            } : editData.notification_config,
        }
    }

    async componentDidMount() {
        const siteData = await axios(`${API_BASE_URL}/site`);
        
        let allEmailUsersList = [];
        let allSmsUsersList = [];
        let customersList = [];
        
        if (this.state.siteId) {
            const customerData = await axios(`${API_BASE_URL}/customer/site/${this.state.siteId}`);
            if (customerData.data && customerData.data.result) {
                allEmailUsersList = [{ label: "Select All", value: "all" }, ...customerData.data.result.map(c => ({
                    value: c._id,
                    label: `${c.customer_name} - ${c.email_id}`
                }))];
        
                allSmsUsersList = [{ label: "Select All", value: "all" }, ...customerData.data.result.map(c => ({
                    value: c._id,
                    label: `${c.customer_name} - ${c.mobile_no}`
                }))];
                
                customersList = customerData.data.result;
            }
        }

        this.setState({
            siteList: siteData.data.result,
            allEmailUsersList: allEmailUsersList,
            allSmsUsersList: allSmsUsersList,
            customersList: customersList,
            isLoading: false,
        });

        const editDataForDowImage = this.props.history.location.state;
        const getCleanFileName = (url) => {
            const decodedUrl = decodeURIComponent(url);
            let fileName = decodedUrl.split("/").pop();

            if (fileName.endsWith('}')) {
                fileName = fileName.slice(0, -1);
            }

            const parts = fileName.split('_');
            if (parts.length > 1) {
                return parts.pop();
            }

            return fileName;
        };

        if (editDataForDowImage) {
            if (editDataForDowImage.defaultImage_uploadedImage) {
                const imageData = editDataForDowImage.defaultImage_uploadedImage;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLink: imageData,
                        downloadFileName: fileName,
                        defaultBackgroundImageOrUplodedImageType: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLink: fileUrl,
                        downloadFileName: fileName,
                        defaultBackgroundImageOrUplodedImageType: { base64Data, fileName }
                    });
                }
            }

            if (editDataForDowImage.client_logoImage_primary) {
                const imageData = editDataForDowImage.client_logoImage_primary;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLinkLogo1: imageData,
                        downloadFileNameLogo1: fileName,
                        primaryLogoImage: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLinkLogo1: fileUrl,
                        downloadFileNameLogo1: fileName,
                        primaryLogoImage: { base64Data, fileName }
                    });
                }
            }

            if (editDataForDowImage.client_logoImage_secondary) {
                const imageData = editDataForDowImage.client_logoImage_secondary;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLinkLogo2: imageData,
                        downloadFileNameLogo2: fileName,
                        secondaryLogoImage: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLinkLogo2: fileUrl,
                        downloadFileNameLogo2: fileName,
                        secondaryLogoImage: { base64Data, fileName }
                    });
                }
            }
        }

    }
    base64ToFile = ({ base64Data, fileName }) => {
        const base64String = base64Data.split(',')[1];
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const fileUrl = URL.createObjectURL(blob);
        return { fileUrl, fileName };
    };

    getFileNameFromEditData = (editData) => {
        if (editData && editData.fileName) {
            return editData.fileName;
        }
        return "No file selected";
    };

    getUrleFromEditData = (editData) => {
        console.log("background image", editData);
        if (editData && typeof editData === 'string') {
            // If it's already a URL, return the full URL, not just filename
            if (editData.startsWith('https')) {
                return editData; // Return full URL
            }
            // If it's just a filename, extract it
            const fileName = editData.replace(/^.*[\\/]/, '');
            console.log("Extracted filename:", fileName);
            return fileName;
        }
        return "No file selected";
    };

    siteNameHandler = (event) => {
        this.setState({
            siteName: event.target.value
        });
    }

    siteStreetHandler = (event) => {
        this.setState({
            siteStreet: event.target.value
        });
    }

    siteCityHandler = (event) => {
        this.setState({
            siteCity: event.target.value
        });
    }

    sitePincodeHandler = (event) => {
        this.setState({
            sitePincode: event.target.value
        });
    }

    siteInactiveHandler = (event) => {
        this.setState({
            siteInactive: event.target.value
        });
    }

    siteTodaysRedaingsToCheckHandler = (event) => {
        this.setState({
            siteTodaysRedaingsToCheck: event.target.value
        });
    }

    isFormValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.siteName) {
            isValid = false;
            error.siteName = "Please enter site name";
        }
        if (!this.state.siteStreet) {
            isValid = false;
            error.siteStreet = "Please enter site street";
        }
        if (!this.state.siteCity) {
            isValid = false;
            error.siteCity = "Please enter site city";
        }
        if (!this.state.sitePincode) {
            isValid = false;
            error.sitePincode = "Please enter site pincode";
        }
        if (this.state.sitePincode !== "undefined") {
            if (!PIN_CODE_PATTERN.test(this.state.sitePincode)) {
                isValid = false;
                error.sitePincode = "Please enter valid Pincode";
            }
        }

        if (!this.state.clientName) {
            isValid = false;
            error.clientName = "Please enter client name";
        }

        if (!this.state.clientID) {
            isValid = false;
            error.clientID = "Please enter clientID";
        }


        if (!this.state.siteInactive) {
            isValid = false;
            error.siteInactive = "Please enter time";
        }

        if (
            !this.state.systemTypeValue ||
            this.state.systemTypeValue.length === 0
        ) {
            isValid = false;
            error.systemTypeValue = "Please select system type";
        }

        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Ami Systems")
        )) {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select  device type";
            }

            if (!this.state.amiAmrRemoteSystemReceiverType || this.state.amiAmrRemoteSystemReceiverType.length === 0) {
                isValid = false;
                error.amiAmrRemoteSystemReceiverType = "Please select systems receiver type";
            }
        }

        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Amr Systems")
        )) {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select  device type";
            }

            if (!this.state.amiAmrRemoteSystemReceiverType || this.state.amiAmrRemoteSystemReceiverType.length === 0) {
                isValid = false;
                error.amiAmrRemoteSystemReceiverType = "Please select systems receiver type";
            }
        }

        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Ami + Remote Configuration")
        )) {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select device type";
            }

            if (!this.state.amiAmrRemoteSystemReceiverType || this.state.amiAmrRemoteSystemReceiverType.length === 0) {
                isValid = false;
                error.amiAmrRemoteSystemReceiverType = "Please select systems receiver type";
            }
        }

        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Ami + Amr Systems")
        )) {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select device type";
            }

            if (!this.state.amiAmrRemoteSystemReceiverType || this.state.amiAmrRemoteSystemReceiverType.length === 0) {
                isValid = false;
                error.amiAmrRemoteSystemReceiverType = "Please select systems receiver type";
            }
        }

        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Ami Systems")
        )) {
            if (this.state.flowColumnSelecetionValue.length === 0) {
                isValid = false;
                error.flowColumnSelecetionValue = "Please select flow columns";
            }
        }
        if (this.state.systemTypeValue?.some(
            item => item.label.includes("Amr Systems")
        )) {
            if (this.state.amrColumnSelecetionValue.length === 0) {
                isValid = false;
                error.amrColumnSelecetionValue = "Please select amr columns";
            }
        }
        // if (!this.state.siteTodaysRedaingsToCheck) {
        //     isValid = false;
        //     error.siteTodaysRedaingsToCheck = "Please enter time";
        // }

        this.setState({
            error
        });
        console.log("error", error)
        return isValid;
    }

    toBase64 = async (file) => {
        if (file && file.base64Data && file.fileName) {
            this.setState({
                base64Data: file.base64Data,
                fileName: file.fileName
            }, () => {
                console.log("State updated:", this.state.base64Data, this.state.fileName);
            });
            return;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result;
                const fileName = file.name;
                resolve({
                    base64Data: base64Data,
                    fileName: fileName
                });
            };

            reader.onerror = (error) => {
                console.error("FileReader error:", error);
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };



    cancelHandler = (event) => {
        this.props.history.push("/sites-page");
    }

    copyHandler = (copiedText, isSuccessful) => {
        if (isSuccessful) {
            console.log(`Copied: ${copiedText}`);
            this.setState({ copiedIconClass: 'copied-text' });

            setTimeout(() => {
                this.setState({ copiedIconClass: " " });
            }, 3500);
            ShowToast('Text copied!', TYPE_SUCCESS, INTERVAL, this.props, "/create-site-page");
        } else {
            console.error('Copy failed');
        }
    };

    siteBackGroundChangeHandler = (event) => {
        this.setState({
            defaultBackgroundImageOrUplodedImageType: event.target.value,
        });
    }

    siteBackGroundChangeHandlerUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileSize = file.size
            const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

            if (fileSize > maxSize) {
                alert('File size should not exceed 100KB.');
                this.setState({ defaultBackgroundImageOrUplodedImageType: "", error: 'File size exceeds 100KB.' });
                event.target.value = "";
            } else {
                this.setState({ defaultBackgroundImageOrUplodedImageType: file, error: '' });
            }
        } else {
            this.setState({ defaultBackgroundImageOrUplodedImageType: "", error: '' });
        }
    }


    siteBackGroundChangeTypesHandler = (event) => {
        this.setState({
            backgroundImageSelectedType: event.target.value,
        })
    }

    systemTypesHandler = (event) => {
        let deviceTypeDisable = true;
        let systemReceiverType = [];

        if (event && event.length > 0) {
            const labels = event.map(item => item.label);
            if (
                labels.includes("Ami Systems") ||
                labels.includes("Amr Systems") ||
                labels.includes("Ami + Remote Configuration") ||
                labels.includes("Ami + Amr Systems")
            ) {
                deviceTypeDisable = false;
            }

            if (labels.includes("Ami Systems")) {
                systemReceiverType.push({ value: "Gateway", label: "Gateway" }, { value: "Mqtt Devices", label: "Mqtt Devices" });
            }
            if (labels.includes("Amr Systems")) {
                systemReceiverType.push({ value: "Aqualink", label: "Aqualink" });
            }
            if (labels.includes("Ami + Amr Systems")) {
                systemReceiverType.push({ value: "Gateway + Aqualink", label: "Gateway + Aqualink" });
            }
            if (labels.includes("Ami + Remote Configuration")) {
                systemReceiverType.push({ value: "Mqtt Devices", label: "Mqtt Devices" });
            }

            systemReceiverType = systemReceiverType.filter((value, index, self) => index === self.findIndex(t => t.value === value.value));
        }

        const labels = event ? event.map(item => item.label) : [];
        this.setState({
            systemTypeValue: event,
            systemReceiverType: systemReceiverType,
            deviceTypeDisable: deviceTypeDisable,
            deviceTypeValue: [],
            flowUnitDisable: labels.includes("Ami + Remote Configuration") ? false : true,
            flowUnitValue: [],
            pressureUnitValue: [],
            levelUnitValue: [],
            temperatureUnitValue: [],
            amiAmrRemoteSystemReceiverType: [],
        });
    }

    amiAmrRemoteSystemReceiverTypesHandler = (event) => {
        this.setState({
            amiAmrRemoteSystemReceiverType: event
        })
    }

    deviceTypesHandler = (selectedOptions) => {
        console.log("device-type", selectedOptions);

        const isOHTSolutionSelected = selectedOptions.some(option => option.value === 'oht solution');
        console.log("isOHTSolutionSelected::", isOHTSolutionSelected)

        const selectedTypes = new Set(selectedOptions.map(option => option.label));
        console.log("selectedTypes::", selectedTypes)

        this.setState({
            deviceTypeValue: selectedOptions || "",
            flowUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Flow'),
            pressureUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Pressure'),
            levelUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Level'),
            temperatureUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Temperature'),

            flowUnitValue: isOHTSolutionSelected ? this.state.flowUnitValue : (!selectedTypes.has('Flow') ? [] : this.state.flowUnitValue),
            pressureUnitValue: isOHTSolutionSelected ? this.state.pressureUnitValue : (!selectedTypes.has('Pressure') ? [] : this.state.pressureUnitValue),
            levelUnitValue: isOHTSolutionSelected ? this.state.levelUnitValue : (!selectedTypes.has('Level') ? [] : this.state.levelUnitValue),
            temperatureUnitValue: isOHTSolutionSelected ? this.state.temperatureUnitValue : (!selectedTypes.has('Temperature') ? [] : this.state.temperatureUnitValue)
        });
    }

    flowColumnSelectionChangeHandler = (item) => {
        this.setState({
            flowColumnSelecetionValue: item
        })
    }

    levelColumnSelectionChangeHandler = (item) => {
        this.setState({
            levelColumnSelecetionValue: item
        })
    }

    amrColumnSelectionChangeHandler = (item) => {
        this.setState({
            amrColumnSelecetionValue: item
        })
    }

    flowUnittypesHandler = (event) => {
        this.setState({
            flowUnitValue: event
        })
    }

    pressureUnitTypesHandler = (event) => {
        this.setState({
            pressureUnitValue: event
        })
    }

    levelUnitTypesHandler = (event) => {
        this.setState({
            levelUnitValue: event
        })
    }

    temperatureUnitTypesHandler = (event) => {
        this.setState({
            temperatureUnitValue: event
        })
    }

    siteClinetNameHandaler = (event) => {
        this.setState({
            clientName: event.target.value
        })
    }
    siteClinetIDHandaler = (event) => {
        this.setState({
            clientID: event.target.value
        })
    }

    sitePrimaryLogoImageChangeHandler = (event) => {
        this.setState({
            primaryLogoImage: event.target.files[0],
        })
    }

    siteSecondaryLogoImageChangeHandler = (event) => {
        this.setState({
            secondaryLogoImage: event.target.files[0],
        })
    }

    subModuleFeatureHandler = (event) => {
        this.setState({
            subModuleFeatureValue: event,
        })
    }

    handleCustomFlowLabelChange = (field, value) => {
        this.setState(prevState => ({
            customFlowColumnLabels: {
                ...prevState.customFlowColumnLabels,
                [field]: value
            }
        }));
    };

    handleCustomLevelLabelChange = (field, value) => {
        this.setState(prevState => ({
            customLevelColumnLabels: {
                ...prevState.customLevelColumnLabels,
                [field]: value
            }
        }));
    };

    handleCustomAmrLabelChange = (field, value) => {
        this.setState(prevState => ({
            customAmrColumnLabels: {
                ...prevState.customAmrColumnLabels,
                [field]: value
            }
        }));
    };


    renderBackGroundImageSelectTypesOptions = () => {
        if (this.state.siteBackGroundImageSelecteTypeList.length > 0) {
            return this.state.siteBackGroundImageSelecteTypeList.map((backgroundimageTypeNameSelectItem, index) => {
                let isSelected = false;
                if (backgroundimageTypeNameSelectItem.value === this.state.backgroundImageSelectedType) {
                    isSelected = true;
                }
                return (
                    <option value={backgroundimageTypeNameSelectItem.value} selected={isSelected} key={backgroundimageTypeNameSelectItem.value} className="option-text-color"> {backgroundimageTypeNameSelectItem.label} </option>
                )
            });
        }
        else {
            return <option disabled> No Data Found</option>
        }
    }

    renderBackGroundImageSelectOptions = () => {
        if (this.state.siteBackGroundImageSelectedList.length > 0) {
            return this.state.siteBackGroundImageSelectedList.map((backgroundimageNameSelectItem, index) => {
                let isSelected = false;
                if (backgroundimageNameSelectItem.value === this.state.defaultBackgroundImageOrUplodedImageType) {
                    isSelected = true;
                }
                return (
                    <option value={backgroundimageNameSelectItem.value} selected={isSelected} key={backgroundimageNameSelectItem.value} className="option-text-color"> {backgroundimageNameSelectItem.label} </option>
                )
            });
        }
        else {
            return <option disabled> No Data Found</option>
        }
    }

    addSiteHandler = async (event) => {
        event.preventDefault();
        if (this.isFormValid()) {
            this.setState({ isLoading: true, });


            let primaryLogoImageData = null;
            const primaryLogoImage = this.state.primaryLogoImage;

            if (!primaryLogoImage || primaryLogoImage === "" || primaryLogoImage === "null") {
                primaryLogoImageData = null;
            }
            else if (typeof primaryLogoImage === "string") {
                primaryLogoImageData = primaryLogoImage;
            }
            else if (primaryLogoImage instanceof File) {
                const result = await this.toBase64(primaryLogoImage);
                primaryLogoImageData = {
                    base64Data: result.base64Data,
                    fileName: result.fileName
                };
            }
            else if (primaryLogoImage && typeof primaryLogoImage === "object") {
                if (primaryLogoImage.base64Data && primaryLogoImage.fileName) {
                    primaryLogoImageData = {
                        base64Data: primaryLogoImage.base64Data,
                        fileName: primaryLogoImage.fileName
                    };
                } else if (primaryLogoImage.url) {
                    primaryLogoImageData = primaryLogoImage.url;
                }
            }

            let secondaryLogoImageData = null;
            const secondaryLogoImage = this.state.secondaryLogoImage;

            if (!secondaryLogoImage || secondaryLogoImage === "" || secondaryLogoImage === "null") {
                secondaryLogoImageData = null;
            }
            else if (typeof secondaryLogoImage === "string") {
                secondaryLogoImageData = secondaryLogoImage;
            }
            else if (secondaryLogoImage instanceof File) {
                const result = await this.toBase64(secondaryLogoImage);
                secondaryLogoImageData = {
                    base64Data: result.base64Data,
                    fileName: result.fileName
                };
            }
            else if (secondaryLogoImage && typeof secondaryLogoImage === "object") {
                if (secondaryLogoImage.base64Data && secondaryLogoImage.fileName) {
                    secondaryLogoImageData = {
                        base64Data: secondaryLogoImage.base64Data,
                        fileName: secondaryLogoImage.fileName
                    };
                } else if (secondaryLogoImage.url) {
                    secondaryLogoImageData = secondaryLogoImage.url;
                }
            }

            let backgroundImageData = null;
            const backgroundImage = this.state.defaultBackgroundImageOrUplodedImageType;

            if (this.state.backgroundImageSelectedType === "upload") {
                if (!backgroundImage || backgroundImage === "" || backgroundImage === "null") {
                    backgroundImageData = null;
                }
                else if (typeof backgroundImage === "string") {
                    backgroundImageData = backgroundImage;
                }
                else if (backgroundImage instanceof File) {
                    const result = await this.toBase64(backgroundImage);
                    backgroundImageData = {
                        base64Data: result.base64Data,
                        fileName: result.fileName
                    };
                }
                else if (backgroundImage && typeof backgroundImage === "object") {
                    if (backgroundImage.base64Data && backgroundImage.fileName) {
                        backgroundImageData = {
                            base64Data: backgroundImage.base64Data,
                            fileName: backgroundImage.fileName
                        };
                    } else if (backgroundImage.url) {
                        backgroundImageData = backgroundImage.url;
                    }
                }
            } else if (this.state.backgroundImageSelectedType === "default images") {
                backgroundImageData = backgroundImage;
            }

            const deviceDataValues = Array.isArray(this.state.deviceTypeValue) ? this.state.deviceTypeValue.map(item => item.label) : [];
            const subModuleFeatureValue = Array.isArray(this.state.subModuleFeatureValue) ? this.state.subModuleFeatureValue.map((item) => { return item.label }) : [];
            const systemModelTypeValue = Array.isArray(this.state.systemTypeValue) ? this.state.systemTypeValue.map((item) => { return item.label }) : [];
            const amiAmrRemoteSystemReceiverTypeValue = Array.isArray(this.state.amiAmrRemoteSystemReceiverType) ? this.state.amiAmrRemoteSystemReceiverType.map((item) => { return item.label }) : [];

            const requestParameter = {
                siteName: this.state.siteName,
                siteStreet: this.state.siteStreet,
                siteCity: this.state.siteCity,
                sitePincode: this.state.sitePincode,
                defaultBackgroundImageOrUplodedImageType: backgroundImageData,
                backgroundImageSelectedType: this.state.backgroundImageSelectedType,
                clientName: this.state.clientName,
                clientID: this.state.clientID,
                systemTypeValue: systemModelTypeValue,
                subModuleFeatureValue: subModuleFeatureValue,
                deviceTypeValue: deviceDataValues,
                amiAmrRemoteSystemReceiverTypeValue: amiAmrRemoteSystemReceiverTypeValue ? amiAmrRemoteSystemReceiverTypeValue : "",
                flowUnitValue: this.state.flowUnitValue.label,
                pressureUnitValue: this.state.pressureUnitValue.label,
                levelUnitValue: this.state.levelUnitValue.label,
                temperatureUnitValue: this.state.temperatureUnitValue.label,
                primaryLogoImage: primaryLogoImageData,
                secondaryLogoImage: secondaryLogoImageData,
                siteInactive: this.state.siteInactive,
                siteTodaysRedaingsToCheck: this.state.siteTodaysRedaingsToCheck,
                backendURL: this.state.backendURL,
                flowColumnSelection: this.state.flowColumnSelecetionValue.label,
                columnAccess: this.state.flowColumnSelecetionValue.label === FLOW_COLUMN_SELECTION_TRUE_VALUE ? this.state.columnAccess : null,
                levelColumnSelection: this.state.levelColumnSelecetionValue?.label,
                levelColumnAccess: this.state.levelColumnSelecetionValue?.label === LEVEL_COLUMN_SELECTION_TRUE_VALUE ? this.state.levelColumnAccess : null,
                amrColumnSelection: this.state.amrColumnSelecetionValue?.label,
                amrColumnAccess: this.state.amrColumnSelecetionValue?.label === AMR_COLUMN_SELECTION_TRUE_VALUE ? this.state.amrColumnAccess : null,
                customFlowColumnLabels: this.state.customFlowColumnLabels,
                customLevelColumnLabels: this.state.customLevelColumnLabels,
                customAmrColumnLabels: this.state.customAmrColumnLabels,
                emailRecipients: this.state.emailRecipients,
                smsRecipients: this.state.smsRecipients,
                notificationConfig: this.state.notificationConfig
            }
            let siteResponse = null;
            if (this.state.siteId === null) {
                siteResponse = await axios.post(`${API_BASE_URL}/site`, requestParameter);
            }
            else {
                siteResponse = await axios.put(`${API_BASE_URL}/site/${this.state.siteId}`, requestParameter);
            }
            const tempSiteId = this.state.siteId;
            if (siteResponse.status === 200) {
                this.setState({
                    siteId: null,
                    siteName: "",
                    siteList: "",
                    siteCity: "",
                    sitePincode: "",
                    backendURL: ""
                }, () => {
                    if (tempSiteId === null) {
                        ShowToast('Site created successfully', TYPE_SUCCESS, INTERVAL, this.props, "/sites-page");
                    }
                    else {
                        ShowToast('Site updated successfully', TYPE_SUCCESS, INTERVAL, this.props, "/sites-page");
                    }
                    this.props.history.push("/sites-page");
                });
            }
        }
    }

    checkIfClientIdAlreadyPresent = async (event) => {
        event.preventDefault();
        const clientID = event.target.value
        const siteDataBasedOnClientId = await axios(`${API_BASE_URL}/site/${clientID}`);
        if (siteDataBasedOnClientId.data.length > 0) {
            ShowToast(`This ${clientID} clientID  is already created`, TYPE_FAIL, INTERVAL, this.props, "");
            this.setState({
                clientID: ""
            })
            return;
        }
    }

    handleEmailRecipientToggle = (customerId) => {
        this.setState(prevState => {
            const currentRecipients = prevState.emailRecipients || [];
            // If selecting all
            if (customerId === 'all') {
                if (currentRecipients.length === prevState.customersList.length) {
                    return { emailRecipients: [] };
                } else {
                    return { emailRecipients: prevState.customersList.map(c => c._id) };
                }
            }
            
            // Individual selection
            const newRecipients = currentRecipients.includes(customerId)
                ? currentRecipients.filter(id => id !== customerId)
                : [...currentRecipients, customerId];
            return { emailRecipients: newRecipients };
        });
    }

    handleSmsRecipientToggle = (customerId) => {
        this.setState(prevState => {
            const currentRecipients = prevState.smsRecipients || [];
            // If selecting all
            if (customerId === 'all') {
                if (currentRecipients.length === prevState.customersList.length) {
                    return { smsRecipients: [] };
                } else {
                    return { smsRecipients: prevState.customersList.map(c => c._id) };
                }
            }
            
            // Individual selection
            const newRecipients = currentRecipients.includes(customerId)
                ? currentRecipients.filter(id => id !== customerId)
                : [...currentRecipients, customerId];
            return { smsRecipients: newRecipients };
        });
    }

    handleToggle = (role, field) => {

        this.setState(prev => ({
            columnAccess: {
                ...prev.columnAccess,
                [role]: {
                    ...prev.columnAccess[role],
                    [field]: !prev.columnAccess[role][field]
                }
            }
        }), () => {
            console.log("columnAccess::", this.state.columnAccess)
        });

    };

    handleLevelToggle = (role, field) => {
        this.setState(prev => ({
            levelColumnAccess: {
                ...prev.levelColumnAccess,
                [role]: {
                    ...prev.levelColumnAccess[role],
                    [field]: !prev.levelColumnAccess[role][field]
                }
            }
        }), () => {
            console.log("levelColumnAccess::", this.state.levelColumnAccess)
        });
    };

    handleAmrToggle = (role, field) => {
        this.setState(prev => ({
            amrColumnAccess: {
                ...prev.amrColumnAccess,
                [role]: {
                    ...prev.amrColumnAccess[role],
                    [field]: !prev.amrColumnAccess[role][field]
                }
            }
        }));
    };

    render() {
        const editData = this.props.history.location.state;
        const showCustomerColumns = Array.isArray(this.state.subModuleFeatureValue) && this.state.subModuleFeatureValue.some(item => item.value === "customeradd-billingcycle" || item.label === "Customer Add - Billing Cycle");
        const customerFields = ["customer_name", "consumer_no", "mobile_no", "email_id"];
        const flowColumns = showCustomerColumns ? FLOW_COLUMN_LIST : FLOW_COLUMN_LIST.filter(col => !customerFields.includes(col.field));
        const levelColumns = showCustomerColumns ? LEVEL_COLUMN_LIST : LEVEL_COLUMN_LIST.filter(col => !customerFields.includes(col.field));
        const amrColumns = showCustomerColumns ? AMR_COLUMN_LIST : AMR_COLUMN_LIST.filter(col => !customerFields.includes(col.field));
        if (this.state.isLoading) {
            return (
                <Spinner />
            )
        }
        else {
            return (
                <div className="main-content">
                    <div className="back">
                        <ul className="breadcrumb1">
                            <li><a href="/sites-page">Site Master</a></li>
                            {
                                this.state.siteId === null ? (
                                    <li>Add New Site</li>
                                ) : (
                                    <li>Edit Site</li>
                                )
                            }
                        </ul>
                    </div>
                    <div className="add-site-main-view">
                        <div className="mx-auto text-left border create-site-div">
                            <form className="pt-1">
                                <div className="site-icon-wrapper">
                                    <h4>{this.state.siteId ? "Edit Site" : "Add New Site"}</h4>
                                    <i className={`${SITE_ICON} list-table-icon`}></i>
                                </div>

                                <div style={{ margin: '0 16px 24px 16px', borderBottom: '2px solid #e2e8f0' }}>
                                    <ul className="nav m-0" role="tablist" style={{ display: 'flex', gap: '8px', marginBottom: '-2px' }}>
                                        <li className="nav-item">
                                            <a className="nav-link" onClick={() => this.setState({ activeTab: 'siteDetails' })} role="tab" style={{ cursor: 'pointer', padding: '0.8rem 2rem', borderRadius: '12px 12px 0 0', fontWeight: '700', fontSize: '16px', color: this.state.activeTab === 'siteDetails' ? '#0070C0' : '#64748b', backgroundColor: this.state.activeTab === 'siteDetails' ? '#fff' : 'transparent', border: this.state.activeTab === 'siteDetails' ? '2px solid #e2e8f0' : '2px solid transparent', borderBottom: this.state.activeTab === 'siteDetails' ? '2px solid #fff' : '2px solid transparent', display: 'flex', alignItems: 'center', transition: 'all 0.2s' }}>
                                                <FaInfoCircle className="mr-2" style={{ position: 'relative', top: '-1px' }} /> Site Details
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" onClick={() => this.setState({ activeTab: 'columnAccess' })} role="tab" style={{ cursor: 'pointer', padding: '0.8rem 2rem', borderRadius: '12px 12px 0 0', fontWeight: '700', fontSize: '16px', color: this.state.activeTab === 'columnAccess' ? '#0070C0' : '#64748b', backgroundColor: this.state.activeTab === 'columnAccess' ? '#fff' : 'transparent', border: this.state.activeTab === 'columnAccess' ? '2px solid #e2e8f0' : '2px solid transparent', borderBottom: this.state.activeTab === 'columnAccess' ? '2px solid #fff' : '2px solid transparent', display: 'flex', alignItems: 'center', transition: 'all 0.2s' }}>
                                                <FaColumns className="mr-2" style={{ position: 'relative', top: '-1px' }} /> Column Access
                                            </a>
                                        </li>
                                        {this.state.siteId && this.state.subModuleFeatureValue && Array.isArray(this.state.subModuleFeatureValue) && this.state.subModuleFeatureValue.some(item => item.value === 'notification' || item.label === 'Notification') && this.state.deviceTypeValue && Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(item => String(item.value).toLowerCase() === 'level' || String(item.label).toLowerCase() === 'level') && (
                                            <li className="nav-item">
                                                <a className="nav-link" onClick={() => this.setState({ activeTab: 'notificationConfig' })} role="tab" style={{ cursor: 'pointer', padding: '0.8rem 2rem', borderRadius: '12px 12px 0 0', fontWeight: '700', fontSize: '16px', color: this.state.activeTab === 'notificationConfig' ? '#0070C0' : '#64748b', backgroundColor: this.state.activeTab === 'notificationConfig' ? '#fff' : 'transparent', border: this.state.activeTab === 'notificationConfig' ? '2px solid #e2e8f0' : '2px solid transparent', borderBottom: this.state.activeTab === 'notificationConfig' ? '2px solid #fff' : '2px solid transparent', display: 'flex', alignItems: 'center', transition: 'all 0.2s' }}>
                                                    <FaBell className="mr-2" style={{ position: 'relative', top: '-1px' }} /> Notification Config
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>

                                <div className="tab-content w-100">
                                    {this.state.activeTab === 'siteDetails' && (
                                        <>
                                            <div className="input-label-group w-100">
                                                <label className="form-label">Site Name <span className="text-danger">*</span></label>
                                                <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteName} onChange={this.siteNameHandler} placeholder="Enter Site Name" />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.siteName}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site Street <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteStreet} onChange={this.siteStreetHandler} placeholder="Enter Site Street" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteStreet}
                                                    </div>
                                                </div>
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site City<span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteCity} onChange={this.siteCityHandler} placeholder="Enter Site City" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteCity}
                                                    </div>
                                                </div>
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site Pincode <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.sitePincode} onChange={this.sitePincodeHandler} placeholder="Enter Site Pincode" maxLength="6" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.sitePincode}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6" id="custom-dropdown">
                                                    <label className="form-label">Site Background image types </label>
                                                    <select
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.siteBackGroundChangeTypesHandler}
                                                        value={this.state.backgroundImageSelectedType}
                                                    //placeholder="Select types"
                                                    >
                                                        <option value="" disabled >Select types</option>
                                                        {
                                                            this.renderBackGroundImageSelectTypesOptions()
                                                        }
                                                    </select>
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageOrUplodedImageType}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.backgroundImageSelectedType === "default images" ? (
                                                        <div className="input-label-group col-md-6" id="custom-dropdown">
                                                            <label className="form-label">Site Background image</label>
                                                            <select
                                                                className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                                onChange={this.siteBackGroundChangeHandler}
                                                                value={this.state.defaultBackgroundImageOrUplodedImageType}
                                                            //placeholder="Select images"
                                                            >
                                                                <option value="" disabled >Select images</option>
                                                                {
                                                                    this.renderBackGroundImageSelectOptions()
                                                                }
                                                            </select>
                                                            <div className="text-danger error-msg">
                                                                {this.state.error.backgroundImage}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        this.state.backgroundImageSelectedType === "upload" && (
                                                            <div className="input-label-group col-md-6">
                                                                <label className="form-label">Upload Site Background image <span className="text-danger">(Max 2MB)</span></label>
                                                                <input
                                                                    type="file"
                                                                    className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                                    onChange={this.siteBackGroundChangeHandlerUpload}
                                                                    accept=".jpg, .jpeg, .png"
                                                                    disabled={this.state.isUploadDisabled}
                                                                />
                                                                <div className="text-danger error-msg">
                                                                    {this.state.error.backgroundImage}
                                                                </div>
                                                                {this.state.downloadLink && (
                                                                    <div style={{ paddingTop: "10px" }}>
                                                                        <a
                                                                            id="download"
                                                                            target="_blank"
                                                                            rel="noreferrer noopener"
                                                                            href={this.state.downloadLink}
                                                                            download={this.state.downloadFileName}
                                                                            style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                                        >
                                                                            Download
                                                                        </a>
                                                                        <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileName}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    )
                                                }
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Client ID <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.clientID} onChange={this.siteClinetIDHandaler} onBlur={this.checkIfClientIdAlreadyPresent} placeholder="Enter client name" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.clientID}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">System Modules <span className="text-danger">*</span></label>
                                                    <div className="add-select-main-div">
                                                        <Select
                                                            placeholder={`Select system modules`}
                                                            value={this.state.systemTypeValue}
                                                            options={SYSTEM_MODULES_TYPES.filter(
                                                                option =>
                                                                    !this.state.systemTypeValue?.some(
                                                                        selected => selected.value === option.value
                                                                    )
                                                            )}
                                                            onChange={this.systemTypesHandler}
                                                            isSearchable={true}
                                                            isMulti={true}
                                                        />
                                                    </div>
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.systemTypeValue}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.systemTypeValue?.length > 0 && (
                                                        <div className="input-label-group col-md-6">
                                                            <label className="form-label">
                                                                System Receiver Type
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="add-select-main-div">
                                                                <Select
                                                                    placeholder={`Select system receiver type`}
                                                                    value={this.state.amiAmrRemoteSystemReceiverType}
                                                                    options={this.state.systemReceiverType}
                                                                    onChange={this.amiAmrRemoteSystemReceiverTypesHandler}
                                                                    isSearchable={true}
                                                                    isMulti
                                                                />
                                                            </div>
                                                            <div className="text-danger error-msg">
                                                                {this.state.error.amiAmrRemoteSystemReceiverType}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    (
                                                        this.state.systemTypeValue?.some(
                                                            item => item.label.includes("Ami Systems")
                                                        ) ||
                                                        this.state.systemTypeValue?.some(
                                                            item => item.label.includes("Amr Systems")
                                                        ) ||
                                                        this.state.systemTypeValue?.some(
                                                            item => item.label.includes("Ami + Amr Systems")
                                                        ) ||
                                                        this.state.systemTypeValue?.some(
                                                            item => item.label.includes("Ami + Remote Configuration")
                                                        )
                                                    ) && (
                                                        <div className="input-label-group col-md-6">
                                                            <label className="form-label">
                                                                Device type <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="add-select-main-div">
                                                                <Select
                                                                    placeholder={`Select device type`}
                                                                    value={this.state.deviceTypeValue}
                                                                    options={this.state.deviceTypesList}
                                                                    onChange={this.deviceTypesHandler}
                                                                    isSearchable={true}
                                                                    isMulti={true}
                                                                    isDisabled={this.state.deviceTypeDisable}
                                                                />
                                                            </div>
                                                            <div className="text-danger error-msg">
                                                                {this.state.error.deviceTypeValue}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="row">
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow") && this.state.systemTypeValue?.some(item => item.label !== "Amr Systems")) && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Flow Column Selection  <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select option`}
                                                                value={this.state.flowColumnSelecetionValue}
                                                                options={this.state.flowColumnSelecetionOptions}
                                                                onChange={this.flowColumnSelectionChangeHandler}
                                                                isSearchable={true}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.flowColumnSelecetionValue}
                                                        </div>
                                                    </div>
                                                )
                                                }

                                                {this.state.systemTypeValue?.some(item => item.label.includes("Amr Systems") || item.label.includes("Ami + Amr Systems")) && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">AMR Column Selection  <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select option`}
                                                                value={this.state.amrColumnSelecetionValue}
                                                                options={this.state.amrColumnSelecetionOptions}
                                                                onChange={this.amrColumnSelectionChangeHandler}
                                                                isSearchable={true}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.amrColumnSelecetionValue}
                                                        </div>
                                                    </div>
                                                )
                                                }

                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level")) && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Level Column Selection  <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select option`}
                                                                value={this.state.levelColumnSelecetionValue}
                                                                options={LEVEL_COLUMN_SELECTION_OPTIONS}
                                                                onChange={this.levelColumnSelectionChangeHandler}
                                                                isSearchable={true}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.levelColumnSelecetionValue}
                                                        </div>
                                                    </div>
                                                )
                                                }
                                            </div>
                                            <div className="row">
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Flow unit<span className="text-danger"> *</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.flowUnitValue}
                                                                options={this.state.flowUnitTypesList}
                                                                onChange={this.flowUnittypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.flowUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.flowUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Pressure")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Pressure unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.pressureUnitValue}
                                                                options={this.state.pressureUnitTypesList}
                                                                onChange={this.pressureUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.pressureUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.pressureUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Level unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.levelUnitValue}
                                                                options={this.state.levelUnitTypesList}
                                                                onChange={this.levelUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.levelUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.levelUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Temperature")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Temperature unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.temperatureUnitValue}
                                                                options={this.state.temperatureUnitTypesList}
                                                                onChange={this.temperatureUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.temperatureUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.temperatureUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Sub module feature <span className="text-danger"></span></label>
                                                    <div className="add-select-main-div">
                                                        <Select
                                                            placeholder={`Select sub module feature`}
                                                            value={this.state.subModuleFeatureValue}
                                                            options={this.state.subModuleFeatureList.filter(
                                                                option =>
                                                                    !this.state.subModuleFeatureValue?.some(
                                                                        selected => selected.label === option.label
                                                                    )
                                                            )}
                                                            onChange={this.subModuleFeatureHandler}
                                                            isSearchable={true}
                                                            isMulti={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Client Name <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.clientName} onChange={this.siteClinetNameHandaler} placeholder="Enter client name" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.clientName}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Upload Site Primary Logo Image <span className="text-danger">(Max 2MB)</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.sitePrimaryLogoImageChangeHandler}
                                                        accept=".jpg, .jpeg, .png"
                                                    />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageType}
                                                    </div>
                                                    {this.state.primaryLogoImage && this.state.downloadLinkLogo1 && (
                                                        <div style={{ paddingTop: "10px" }}>
                                                            <a
                                                                id="download"
                                                                href={this.state.downloadLinkLogo1}
                                                                download={this.state.downloadFileNameLogo1}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                                style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                            >
                                                                Download
                                                            </a>
                                                            <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileNameLogo1}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Upload Site Secondary Logo Image <span className="text-danger">(Max 2MB)</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.siteSecondaryLogoImageChangeHandler}
                                                        accept=".jpg, .jpeg, .png"
                                                    />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageType}
                                                    </div>
                                                    {this.state.secondaryLogoImage && this.state.downloadLinkLogo2 && (
                                                        <div style={{ paddingTop: "10px" }}>
                                                            <a
                                                                id="download"
                                                                href={this.state.downloadLinkLogo2}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                                download={this.state.downloadFileNameLogo2}
                                                                style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                            >
                                                                Download
                                                            </a>
                                                            <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileNameLogo2}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Backend URL</label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.backendURL} onChange={this.backendURLHandler} placeholder="Enter backend URL" />
                                                </div>
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Mark Meter Inactive After  <span className="text-danger">(Hours)  </span><span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.siteInactive} onChange={this.siteInactiveHandler} placeholder="Enter Hours" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteInactive}
                                                    </div>
                                                </div>
                                                {/* <div className="input-label-group col-md-6">
                                        <label className="form-label">Todays Consumption Readings Check After  <span className="text-danger">(Hours)  </span><span className="text-danger">*</span></label>
                                        <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.siteTodaysRedaingsToCheck} onChange={this.siteTodaysRedaingsToCheckHandler} placeholder="Enter Hours" />
                                        <div className="text-danger error-msg">
                                            {this.state.error.siteTodaysRedaingsToCheck}
                                        </div>
                                    </div> */}
                                                {
                                                    this.state.siteId && (
                                                        <div className="input-label-group col-md-12">
                                                            <label className="form-label">Site Login URL </label>
                                                            <div className='site-url-div'>
                                                                <CopyToClipboard text={`${WEB_APP_URL}/login/${this.state.clientID}`} onCopy={this.copyHandler}>
                                                                    <label className="form-label brand-font p-3 placeholderColor add-meter-input text-transform-none pl-0">
                                                                        {`${WEB_APP_URL}/login/${this.state.clientID}`}
                                                                        <br />
                                                                        <i className={`${COPY_ICON} list-table-icon copy-icon ${this.state.copiedIconClass}`}></i>
                                                                    </label>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </>
                                    )}

                                    {this.state.activeTab === 'columnAccess' && (
                                        <div className="row mt-3 px-3">
                                            {(() => {
                                                const isFlowActive = Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow") && this.state.systemTypeValue?.some(item => item.label !== "Amr Systems");
                                                const isLevelActive = Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level") && this.state.systemTypeValue?.some(item => item.label !== "Amr Systems");
                                                const isAmrActive = Array.isArray(this.state.systemTypeValue) && this.state.systemTypeValue.some(system => system.value === "Amr Systems");

                                                const activeSections = [];
                                                if (isFlowActive) activeSections.push({ id: 'flow', label: 'Flow Column' });
                                                if (isLevelActive) activeSections.push({ id: 'level', label: 'Level Column' });
                                                if (isAmrActive) activeSections.push({ id: 'amr', label: 'AMR Column' });

                                                const currentInnerTab = this.state.activeColumnAccessTab || (activeSections.length > 0 ? activeSections[0].id : null);

                                                return (
                                                    <div className="w-100">
                                                        {activeSections.length > 1 && (
                                                            <div className="d-flex justify-content-center mb-4 w-100">
                                                                <div style={{ borderBottom: '2px solid #e2e8f0', display: 'inline-block' }}>
                                                                    <ul className="nav m-0" role="tablist" style={{ display: 'flex', gap: '8px', marginBottom: '-2px' }}>
                                                                        {activeSections.map(section => (
                                                                            <li className="nav-item" key={section.id}>
                                                                                <a 
                                                                                    className="nav-link"
                                                                                    onClick={() => this.setState({ activeColumnAccessTab: section.id })}
                                                                                    style={{ 
                                                                                        cursor: 'pointer', 
                                                                                        padding: '0.6rem 2rem', 
                                                                                        borderRadius: '12px 12px 0 0', 
                                                                                        fontWeight: '700', 
                                                                                        fontSize: '15px',
                                                                                        color: currentInnerTab === section.id ? '#0070C0' : '#64748b', 
                                                                                        backgroundColor: currentInnerTab === section.id ? '#fff' : 'transparent', 
                                                                                        border: currentInnerTab === section.id ? '2px solid #e2e8f0' : '2px solid transparent', 
                                                                                        borderBottom: currentInnerTab === section.id ? '2px solid #fff' : '2px solid transparent', 
                                                                                        transition: 'all 0.2s', 
                                                                                        display: 'flex', 
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                >
                                                                                    {section.label}
                                                                                </a>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Flow Column Permissions */}
                                                        {isFlowActive && (activeSections.length === 1 || currentInnerTab === 'flow') && (
                                                            this.state.flowColumnSelecetionValue.label === FLOW_COLUMN_SELECTION_TRUE_VALUE ? (
                                                                <div className="input-label-group col-md-12 mb-4">
                                                                    <label className="form-label mb-3" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>Flow Readings Column Permission</label>
                                                        <div className="column-permission-container">
                                                            <div className="column-permission-header" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                <div>Column</div>
                                                                <div className="toggle-header">Super Admin</div>
                                                                <div className="toggle-header">Admin</div>
                                                                <div className="toggle-header">Reader</div>
                                                            </div>
                                                            {flowColumns.map(column => (
                                                                <div key={column.field} className="column-permission-row" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                    <div className="column-name">
                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 0' }}>
                                                                            <input
                                                                                type="text"
                                                                                value={this.state.customFlowColumnLabels[column.field] !== undefined ? this.state.customFlowColumnLabels[column.field] : column.label}
                                                                                onChange={(e) => this.handleCustomFlowLabelChange(column.field, e.target.value)}
                                                                                style={{
                                                                                    border: '1px solid #ced4da',
                                                                                    borderRadius: '4px',
                                                                                    outline: 'none',
                                                                                    color: '#495057',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: '500',
                                                                                    width: '90%',
                                                                                    padding: '4px 8px'
                                                                                }}
                                                                            />
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
                                                                                <span style={{ fontSize: '11px', color: '#888' }}>{column.label} value can be edited</span>
                                                                                {this.state.customFlowColumnLabels[column.field] !== undefined && this.state.customFlowColumnLabels[column.field] !== column.label && (
                                                                                    <span 
                                                                                        className="reset-btn"
                                                                                        style={{ fontSize: '11px', color: '#0070C0', cursor: 'pointer', textDecoration: 'underline' }} 
                                                                                        onClick={() => this.handleCustomFlowLabelChange(column.field, column.label)}
                                                                                    >
                                                                                        Reset
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.columnAccess.superadmin[column.field] || false}
                                                                                onChange={() => this.handleToggle("superadmin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.columnAccess.admin[column.field] || false}
                                                                                onChange={() => this.handleToggle("admin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.columnAccess.reader[column.field] || false}
                                                                                onChange={() => this.handleToggle("reader", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="col-md-12 text-center p-3 mb-4 border rounded bg-light">
                                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Please select "Yes" for Flow Column Selection in the Site Details tab to manage flow column access.</p>
                                                    </div>
                                                )
                                            )}

                                            {/* Level Column Permissions */}
                                            {isLevelActive && (activeSections.length === 1 || currentInnerTab === 'level') && (
                                                this.state.levelColumnSelecetionValue?.label === LEVEL_COLUMN_SELECTION_TRUE_VALUE ? (
                                                    <div className="input-label-group col-md-12">
                                                        <label className="form-label mb-3" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>Level Readings Column Permission</label>
                                                        <div className="column-permission-container">
                                                            <div className="column-permission-header" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                <div>Column</div>
                                                                <div className="toggle-header">Super Admin</div>
                                                                <div className="toggle-header">Admin</div>
                                                                <div className="toggle-header">Reader</div>
                                                            </div>
                                                            {levelColumns.map(column => (
                                                                <div key={column.field} className="column-permission-row" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                    <div className="column-name">
                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 0' }}>
                                                                            <input
                                                                                type="text"
                                                                                value={this.state.customLevelColumnLabels[column.field] !== undefined ? this.state.customLevelColumnLabels[column.field] : column.label}
                                                                                onChange={(e) => this.handleCustomLevelLabelChange(column.field, e.target.value)}
                                                                                style={{
                                                                                    border: '1px solid #ced4da',
                                                                                    borderRadius: '4px',
                                                                                    outline: 'none',
                                                                                    color: '#495057',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: '500',
                                                                                    width: '90%',
                                                                                    padding: '4px 8px'
                                                                                }}
                                                                            />
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
                                                                                <span style={{ fontSize: '11px', color: '#888' }}>{column.label} value can be edited</span>
                                                                                {this.state.customLevelColumnLabels[column.field] !== undefined && this.state.customLevelColumnLabels[column.field] !== column.label && (
                                                                                    <span 
                                                                                        className="reset-btn"
                                                                                        style={{ fontSize: '11px', color: '#0070C0', cursor: 'pointer', textDecoration: 'underline' }} 
                                                                                        onClick={() => this.handleCustomLevelLabelChange(column.field, column.label)}
                                                                                    >
                                                                                        Reset
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.superadmin[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("superadmin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.admin[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("admin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.reader[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("reader", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="col-md-12 text-center p-3 border rounded bg-light">
                                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Please select "Yes" for Level Column Selection in the Site Details tab to manage level column access.</p>
                                                    </div>
                                                )
                                            )}

                                            {/* Fallback if no columns active */}
                                            {activeSections.length === 0 && (
                                                <div className="col-md-12 text-center p-5">
                                                    <p className="text-muted" style={{ fontSize: "16px" }}>Please select "Flow", "Level", or "Amr Systems" in the Site Details tab to manage column access.</p>
                                                </div>
                                            )}

                                        {isAmrActive && (activeSections.length === 1 || currentInnerTab === 'amr') && (
                                            this.state.amrColumnSelecetionValue?.label === AMR_COLUMN_SELECTION_TRUE_VALUE ? (
                                                <div className="input-label-group col-md-12 mb-4 mt-3">
                                                    <label className="form-label mb-3" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>AMR Readings Column Permission</label>
                                                    <div className="column-permission-container">
                                                        <div className="column-permission-header" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                            <div>Column</div>
                                                            <div className="toggle-header">Super Admin</div>
                                                            <div className="toggle-header">Admin</div>
                                                            <div className="toggle-header">Reader</div>
                                                        </div>
                                                        {amrColumns.map((column, index) => (
                                                            <div key={index} className="column-permission-row" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                <div className="column-name">
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 0' }}>
                                                                        <input
                                                                            type="text"
                                                                            value={this.state.customAmrColumnLabels[column.field] !== undefined ? this.state.customAmrColumnLabels[column.field] : column.label}
                                                                            onChange={(e) => this.handleCustomAmrLabelChange(column.field, e.target.value)}
                                                                            style={{
                                                                                border: '1px solid #ced4da',
                                                                                borderRadius: '4px',
                                                                                outline: 'none',
                                                                                color: '#495057',
                                                                                fontSize: '14px',
                                                                                fontWeight: '500',
                                                                                width: '90%',
                                                                                padding: '4px 8px'
                                                                            }}
                                                                        />
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
                                                                            <span style={{ fontSize: '11px', color: '#888' }}>{column.label} value can be edited</span>
                                                                            {this.state.customAmrColumnLabels[column.field] !== undefined && this.state.customAmrColumnLabels[column.field] !== column.label && (
                                                                                <span 
                                                                                    className="reset-btn"
                                                                                    style={{ fontSize: '11px', color: '#0070C0', cursor: 'pointer', textDecoration: 'underline' }} 
                                                                                    onClick={() => this.handleCustomAmrLabelChange(column.field, column.label)}
                                                                                >
                                                                                    Reset
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="column-toggle">
                                                                    <label className="switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.amrColumnAccess.superadmin[column.field] || false}
                                                                            onChange={() => this.handleAmrToggle('superadmin', column.field)}
                                                                        />
                                                                        <span className="slider"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="column-toggle">
                                                                    <label className="switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.amrColumnAccess.admin[column.field] || false}
                                                                            onChange={() => this.handleAmrToggle('admin', column.field)}
                                                                        />
                                                                        <span className="slider"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="column-toggle">
                                                                    <label className="switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.amrColumnAccess.reader[column.field] || false}
                                                                            onChange={() => this.handleAmrToggle('reader', column.field)}
                                                                        />
                                                                        <span className="slider"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="col-md-12 text-center p-3 border rounded bg-light">
                                                    <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Please select "Yes" for AMR Column Selection in the Site Details tab to manage AMR column access.</p>
                                                </div>
                                            )
                                        )}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    )}
                                    {this.state.activeTab === 'notificationConfig' && this.state.deviceTypeValue && Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(item => String(item.value).toLowerCase() === 'level' || String(item.label).toLowerCase() === 'level') && (
                                        <div className="row p-3">
                                            <div className="col-md-12">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <label className="form-label mb-0" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>Notification Configuration</label>
                                                    <ul className="nav nav-pills m-0" role="tablist" style={{ backgroundColor: '#f1f5f9', padding: '4px', borderRadius: '8px', display: 'inline-flex' }}>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${(this.state.activeNotificationTab || 'emailRecipients') === 'emailRecipients' ? 'active' : ''}`} onClick={() => this.setState({ activeNotificationTab: 'emailRecipients' })} role="tab" style={{ cursor: 'pointer', padding: '0.4rem 1.2rem', borderRadius: '6px', fontWeight: (this.state.activeNotificationTab || 'emailRecipients') === 'emailRecipients' ? '600' : '500', color: (this.state.activeNotificationTab || 'emailRecipients') === 'emailRecipients' ? '#fff' : '#64748b', backgroundColor: (this.state.activeNotificationTab || 'emailRecipients') === 'emailRecipients' ? '#0070C0' : 'transparent', transition: 'all 0.2s', border: 'none' }}>
                                                                <FaEnvelope className="mr-2" style={{ position: 'relative', top: '-1px' }}/> Email
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${(this.state.activeNotificationTab || 'emailRecipients') === 'smsRecipients' ? 'active' : ''}`} onClick={() => this.setState({ activeNotificationTab: 'smsRecipients' })} role="tab" style={{ cursor: 'pointer', padding: '0.4rem 1.2rem', borderRadius: '6px', fontWeight: (this.state.activeNotificationTab || 'emailRecipients') === 'smsRecipients' ? '600' : '500', color: (this.state.activeNotificationTab || 'emailRecipients') === 'smsRecipients' ? '#fff' : '#64748b', backgroundColor: (this.state.activeNotificationTab || 'emailRecipients') === 'smsRecipients' ? '#0070C0' : 'transparent', transition: 'all 0.2s', border: 'none' }}>
                                                                <FaSms className="mr-2" style={{ position: 'relative', top: '-1px' }}/> SMS
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="column-permission-container mt-2" style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)' }}>
                                                    <div className="column-permission-header" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr", backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '16px 20px', color: '#475569', textTransform: 'uppercase', fontSize: '12px', fontWeight: '700', letterSpacing: '0.05em' }}>
                                                        <div>Event Type</div>
                                                        <div className="toggle-header" style={{ textAlign: 'center' }}>Email Send</div>
                                                        <div className="toggle-header" style={{ textAlign: 'center' }}>SMS</div>
                                                        <div className="toggle-header" style={{ textAlign: 'center' }}>Send Frequency</div>
                                                    </div>
                                                    
                                                    <div className="column-permission-row" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr", padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
                                                        <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span style={{ fontSize: '15px', fontWeight: '600', color: '#334155' }}>Level Critical Status</span>
                                                        </div>
                                                        <div className="column-toggle">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.notificationConfig?.level_critical_status?.email_send === "Yes"}
                                                                    onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, level_critical_status: { ...this.state.notificationConfig.level_critical_status, email_send: e.target.checked ? "Yes" : "No" } } })}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                        <div className="column-toggle">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.notificationConfig?.level_critical_status?.sms_send === "Yes"}
                                                                    onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, level_critical_status: { ...this.state.notificationConfig.level_critical_status, sms_send: e.target.checked ? "Yes" : "No" } } })}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                        <div className="column-toggle" style={{ justifyContent: 'center' }}>
                                                            <div className="d-flex align-items-center" style={{ backgroundColor: '#f8fafc', padding: '4px 8px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                                                <input type="number" className="form-control text-center mr-2" style={{ width: '80px', height: '32px', border: 'none', backgroundColor: 'transparent', boxShadow: 'none', fontWeight: '600', color: '#334155', padding: '0' }} placeholder="Hrs" value={this.state.notificationConfig?.level_critical_status?.send_frequency || ""} onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, level_critical_status: { ...this.state.notificationConfig.level_critical_status, send_frequency: e.target.value } } })} />
                                                                <span style={{ fontSize: '13px', color: '#64748b', fontWeight: '600', paddingRight: '4px' }}>hrs</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="column-permission-row" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr", padding: '16px 20px' }}>
                                                        <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span style={{ fontSize: '15px', fontWeight: '600', color: '#334155' }}>Meter Inactive Status</span>
                                                        </div>
                                                        <div className="column-toggle">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.notificationConfig?.meter_inactive_status?.email_send === "Yes"}
                                                                    onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, meter_inactive_status: { ...this.state.notificationConfig.meter_inactive_status, email_send: e.target.checked ? "Yes" : "No" } } })}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                        <div className="column-toggle">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.notificationConfig?.meter_inactive_status?.sms_send === "Yes"}
                                                                    onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, meter_inactive_status: { ...this.state.notificationConfig.meter_inactive_status, sms_send: e.target.checked ? "Yes" : "No" } } })}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                        <div className="column-toggle" style={{ justifyContent: 'center' }}>
                                                            <div className="d-flex align-items-center" style={{ backgroundColor: '#f8fafc', padding: '4px 8px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                                                <input type="number" className="form-control text-center mr-2" style={{ width: '80px', height: '32px', border: 'none', backgroundColor: 'transparent', boxShadow: 'none', fontWeight: '600', color: '#334155', padding: '0' }} placeholder="Hrs" value={this.state.notificationConfig?.meter_inactive_status?.send_frequency || ""} onChange={(e) => this.setState({ notificationConfig: { ...this.state.notificationConfig, meter_inactive_status: { ...this.state.notificationConfig.meter_inactive_status, send_frequency: e.target.value } } })} />
                                                                <span style={{ fontSize: '13px', color: '#64748b', fontWeight: '600', paddingRight: '4px' }}>hrs</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        {(this.state.activeNotificationTab || 'emailRecipients') === 'emailRecipients' && (
                                            <div className="col-md-12 mt-2">
                                                <label className="form-label mb-3" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>Email Recipients</label>
                                                <div className="column-permission-container mt-2" style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
                                                    <div className="column-permission-header" style={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr", backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '16px 20px', color: '#475569', textTransform: 'uppercase', fontSize: '12px', fontWeight: '700', letterSpacing: '0.05em' }}>
                                                        <div>Sr. No</div>
                                                        <div>Meter Serial Number</div>
                                                        <div>Customer Name</div>
                                                        <div>Customer Email</div>
                                                        <div className="toggle-header d-flex justify-content-center align-items-center">
                                                            <span className="mr-2">Select All</span>
                                                            <label className="switch mb-0" style={{ transform: 'scale(1)' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.customersList.length > 0 && this.state.emailRecipients.length === this.state.customersList.length}
                                                                    onChange={() => this.handleEmailRecipientToggle('all')}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {this.state.customersList && this.state.customersList.map((customer, index) => (
                                                        <div className="column-permission-row" style={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr", padding: '12px 20px', borderBottom: '1px solid #f1f5f9' }} key={customer._id}>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#64748b' }}>
                                                                    {String(index + 1).padStart(2, '0')}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#334155' }}>
                                                                    {Array.isArray(customer.serial_number) ? customer.serial_number.join(", ") : customer.serial_number}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#334155' }}>
                                                                    {customer.customer_name}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '400', color: customer.email_id ? '#334155' : '#94a3b8' }}>
                                                                    {customer.email_id ? customer.email_id : "None"}
                                                                </span>
                                                            </div>
                                                            <div className="column-toggle">
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.emailRecipients.includes(customer._id)}
                                                                        onChange={() => this.handleEmailRecipientToggle(customer._id)}
                                                                    />
                                                                    <span className="slider"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {(!this.state.customersList || this.state.customersList.length === 0) && (
                                                        <div className="text-center p-3 text-muted">No customers assigned to this site yet.</div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {(this.state.activeNotificationTab || 'emailRecipients') === 'smsRecipients' && (
                                            <div className="col-md-12 mt-2">
                                                <label className="form-label mb-3" style={{ fontSize: "18px", fontWeight: "800", background: "linear-gradient(90deg, #1e293b 0%, #0070C0 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "0.5px", display: "inline-block" }}>SMS Recipients</label>
                                                <div className="column-permission-container mt-2" style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
                                                    <div className="column-permission-header" style={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr", backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '16px 20px', color: '#475569', textTransform: 'uppercase', fontSize: '12px', fontWeight: '700', letterSpacing: '0.05em' }}>
                                                        <div>Sr. No</div>
                                                        <div>Meter Serial Number</div>
                                                        <div>Customer Name</div>
                                                        <div>Customer Number</div>
                                                        <div className="toggle-header d-flex justify-content-center align-items-center">
                                                            <span className="mr-2">Select All</span>
                                                            <label className="switch mb-0" style={{ transform: 'scale(1)' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.customersList.length > 0 && this.state.smsRecipients.length === this.state.customersList.length}
                                                                    onChange={() => this.handleSmsRecipientToggle('all')}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {this.state.customersList && this.state.customersList.map((customer, index) => (
                                                        <div className="column-permission-row" style={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr", padding: '12px 20px', borderBottom: '1px solid #f1f5f9' }} key={customer._id}>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#64748b' }}>
                                                                    {String(index + 1).padStart(2, '0')}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#334155' }}>
                                                                    {Array.isArray(customer.serial_number) ? customer.serial_number.join(", ") : customer.serial_number}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#334155' }}>
                                                                    {customer.customer_name}
                                                                </span>
                                                            </div>
                                                            <div className="column-name" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '14px', fontWeight: '400', color: customer.mobile_no ? '#334155' : '#94a3b8' }}>
                                                                    {customer.mobile_no ? customer.mobile_no : "None"}
                                                                </span>
                                                            </div>
                                                            <div className="column-toggle">
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.smsRecipients.includes(customer._id)}
                                                                        onChange={() => this.handleSmsRecipientToggle(customer._id)}
                                                                    />
                                                                    <span className="slider"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {(!this.state.customersList || this.state.customersList.length === 0) && (
                                                        <div className="text-center p-3 text-muted">No customers assigned to this site yet.</div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                    )}
                                </div>

                                <div className="btn-container">
                                    <button className="brand-button" onClick={this.addSiteHandler} >Submit</button>
                                    <button className="cancel_button" onClick={this.cancelHandler}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default CreateSitePage